/** Adresses des images des cartes (seau privé) : adresses temporaires gardées en cache. */
import { useMemo } from 'react';
import { useDonnees } from './contexte';

const DUREE_SECONDES = 3600;

export function useImages() {
  const { depot } = useDonnees();
  return useMemo(() => {
    const cache = new Map<string, { adresse: Promise<string>; expire: number }>();
    return {
      resoudre(chemin: string): Promise<string> {
        const existant = cache.get(chemin);
        if (existant && existant.expire > Date.now()) return existant.adresse;
        const adresse = depot.adresseImage(chemin, DUREE_SECONDES);
        cache.set(chemin, { adresse, expire: Date.now() + (DUREE_SECONDES - 300) * 1000 });
        adresse.catch(() => cache.delete(chemin));
        return adresse;
      },
      envoyer: (image: Blob, extension: string) => depot.envoyerImage(image, extension),
    };
  }, [depot]);
}
